import React, { useEffect, useState } from 'react';

import { Box } from '@sunwisesoftware/sunwise-ui';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import alerts from 'common/modules/alerts';

import * as editTemplateViewActions from '../../../modules/editTemplateView/actions';
import * as profileActions from '../../../modules/profile/actions';
import * as profileSelectors from '../../../modules/profile/selectors';

import Footer from './Footer';
import SideBar from './SideBar';
import TopBar from './TopBar';

const DefaultLayout = ({
    children,
    fetchUserSettings,
    match,
    profileValues,
    redirect,
    selectedTheme,
    setDrawerSizeForTemplates,
    setTheme,
}) => {
    const [drawerSize, setDrawerSize] = useState('normal');
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        fetchUserSettings();
        const selectedDrawerSize = localStorage.getItem('selectedDrawerSize');
        if (selectedDrawerSize) setDrawerSize(selectedDrawerSize);
    }, []);

    const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

    const toggleDrawerSize = () => {
        const newDrawerSize = drawerSize === 'normal' ? 'small' : 'normal';
        setDrawerSize(newDrawerSize);
        setDrawerSizeForTemplates(newDrawerSize);
        localStorage.setItem('selectedDrawerSize', newDrawerSize);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
            <SideBar
                drawerSize={drawerSize}
                handleDrawerToggle={handleDrawerToggle}
                match={match}
                mobileOpen={mobileOpen}
                profileValues={profileValues}
                redirect={redirect}
                selectedTheme={selectedTheme}
                setTheme={setTheme}
                toggleDrawerSize={toggleDrawerSize}
            />

            <Box
                component="main"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    ml: { md: '86px' },
                    pt: { xs: '65px', md: 0 },
                    width: { md: 'calc(100% - 86px)' },
                    ...(drawerSize === 'small' && {
                        ml: { md: '50px' },
                        width: { md: 'calc(100% - 50px)' },
                    }),
                }}
            >
                <TopBar
                    availableProjects={0}
                    handleDrawerToggle={handleDrawerToggle}
                    redirect={redirect}
                />

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                    }}
                >
                    {children}
                </Box>
                <Footer />
            </Box>
            <alerts.Container />
        </Box>
    );
};

const mapStateToProps = createStructuredSelector({
    profileValues: profileSelectors.getCurrentValues,
    selectedTheme: profileSelectors.getTheme,
});

const mapDispatchToProps = (dispatch) => ({
    fetchUserSettings: () => dispatch(profileActions.fetchData()),
    redirect: (link) => dispatch(push(link)),
    setDrawerSizeForTemplates: (value) =>
        dispatch(editTemplateViewActions.setDrawerSize(value)),
    setTheme: (value) => dispatch(profileActions.setTheme(value)),
});

DefaultLayout.propTypes = {
    children: PropTypes.object,
    fetchUserSettings: PropTypes.func,
    match: PropTypes.object,
    profileValues: PropTypes.object,
    redirect: PropTypes.func,
    selectedTheme: PropTypes.string,
    setDrawerSizeForTemplates: PropTypes.func,
    setTheme: PropTypes.func,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(DefaultLayout));
